import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      id="prefix__icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 192 192"
      {...props}
    >
      <style>{".prefix__st0{stroke:#333}"}</style>
      <path
        className="prefix__st0"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8.67}
        d="M44 148L148 44M148 148L44 44"
      />
    </svg>
  )
}

export default SvgComponent
